import * as React from "react";

function simpleHash(str: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return ("0000000" + h.toString(16)).slice(-8);
}

function hashCanvas(): string {
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return "noctx";
    canvas.width = 240;
    canvas.height = 60;
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(0, 0, 240, 60);
    ctx.fillStyle = "#069";
    ctx.font = "14px Arial";
    ctx.fillText("fp!@#$% 123", 2, 22);
    ctx.strokeStyle = "rgba(102, 204, 0, 0.7)";
    ctx.strokeRect(1, 1, 238, 58);
    const data = canvas.toDataURL();
    return simpleHash(data);
  } catch {
    return "canvas-err";
  }
}

function collectSignals(): Record<string, unknown> {
  const nav = typeof navigator !== "undefined" ? navigator : ({} as Navigator);
  const scr = typeof screen !== "undefined" ? screen : ({} as Screen);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const offset = new Date().getTimezoneOffset();
  const langs = Array.isArray(nav.languages) ? nav.languages.slice(0, 5) : [];
  return {
    ua: (nav.userAgent || "").slice(0, 200),
    platform: (nav as any).platform || "",
    lang: nav.language || "",
    langs,
    screen: `${scr.width || 0}x${scr.height || 0}x${scr.colorDepth || 0}`,
    dpr: (window as any).devicePixelRatio || 1,
    tz,
    tzOffset: offset,
    cores: (nav as any).hardwareConcurrency || 0,
    mem: (nav as any).deviceMemory || 0,
    touch: "ontouchstart" in window || (nav as any).maxTouchPoints > 0,
  };
}

async function getDeviceFingerprint(): Promise<string> {
  const signals = collectSignals();
  const canvas = hashCanvas();
  const base = JSON.stringify({ ...signals, canvas });
  return simpleHash(base);
}

function collectClientMetadata(): Record<string, unknown> {
  return collectSignals();
}

export function useDeviceFingerprint() {
  const [fp, setFp] = React.useState<string>("");
  const [meta, setMeta] = React.useState<Record<string, unknown>>(() => collectClientMetadata());

  React.useEffect(() => {
    let cancelled = false;
    getDeviceFingerprint()
      .then((f) => {
        if (!cancelled) setFp(f);
      })
      .catch(() => {
        if (!cancelled) setFp("err-" + Date.now().toString(36));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { fp, meta, ready: fp.length > 0 };
}
